// extracted by mini-css-extract-plugin
export var accordionWrapper = "j_J";
export var addTransition = "j_K";
export var content = "j_L";